/* @jsx h */
import { defineComponent, h, ref } from "vue";

type RestaurantSwitcherImageProps = {
  name: string;
  url?: string | null;
};

export const RestaurantSwitcherImage =
  defineComponent<RestaurantSwitcherImageProps>({
    name: "RestaurantSwitcherImage",
    props: ["name", "url"],
    setup(props) {
      const failedUrl = ref<string | null>(null);

      return () => {
        const initial = props.name.trim().charAt(0).toUpperCase() || "?";

        return props.url && failedUrl.value !== props.url ? (
          <img
            src={props.url}
            alt={props.name}
            class="h-6 w-6 flex-shrink-0 rounded-md border border-base-content/10 bg-base-100 object-cover"
            loading="lazy"
            onError={() => {
              failedUrl.value = props.url ?? null;
            }}
          />
        ) : (
          <span
            aria-hidden="true"
            class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md border border-base-content/10 bg-base-content/10 text-[11px] font-semibold text-base-content/70"
          >
            {initial}
          </span>
        );
      };
    },
  });
